<!-- 考生报考登记 -->
<template>
  <div class="register">
    <el-form
      ref="form"
      :model="form"
      inline
      class="form"
      id="form"
      label-width="100px"
    >
      <el-form-item label="查询日期">
        <el-date-picker
          value-format="yyyy-MM-dd"
          v-model="form.dateQuery"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item label="关键字">
        <el-input
          v-model="form.search"
          placeholder="请输入姓名/报名单号/身份证/准考证号"
        ></el-input>
      </el-form-item>
      <el-form-item label="单据状态">
        <el-select
          v-model="form.condition"
          placeholder="请选择单据状态"
          :clearable="true"
        >
          <el-option
            v-for="item in form.conditionChoose"
            :key="item.id"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="考试大类">
        <el-select
          v-model="form.exam"
          filterable
          placeholder="请选择考试大类"
          :clearable="true"
        >
          <el-option
            v-for="item in form.examOpt"
            :key="item.id"
            :label="item.exam_name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="选择机构">
        <el-select
          v-model="form.mechanism"
          filterable
          placeholder="请输入并选择"
          :clearable="true"
        >
          <el-option
            v-for="item in form.mechanismChoose"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="异常">
        <el-select
          v-model="form.abnormal"
          placeholder="请选择"
          :clearable="true"
        >
          <el-option
            v-for="item in form.abnormalChoose"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="科目">
        <el-select
          v-model="form.subject"
          filterable
          placeholder="请选择"
          :clearable="true"
        >
          <el-option
            v-for="item in form.subjectOpt"
            :key="item.id"
            :label="item.course_name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="报考等级">
        <el-select v-model="form.grade" placeholder="请选择" :clearable="true">
          <el-option
            v-for="item in form.gradeOpt"
            :key="item.id"
            :label="item.level"
            :value="item.level"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="考场安排">
        <el-select
          v-model="form.arrange"
          placeholder="请选择"
          :clearable="true"
          @change="arrange"
        >
          <el-option
            v-for="item in form.arrangeOpt"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="分组码A">
        <el-input
          v-model="form.usesearch"
          placeholder="请输入分组码"
        ></el-input>
      </el-form-item>
    </el-form>

    <!-- 按钮功能部分 -->
    <div class="" style="display: flex; justify-content: space-between">
      <div class="" style="margin-left: 22px">
        <el-button
          size="small"
          icon="el-icon-refresh"
          style="background-color: #2c3e50; border-radius: 3px"
          @click="refresh"
        >
          <!-- 刷新 -->
        </el-button>
        <el-button
          size="small"
          icon="el-icon-plus"
          style="background: #18bc9c; color: #ffffff"
          @click="newlyAdded"
        >
          新增
        </el-button>
        <button class="print" @click="print">打印预览</button>
        <button class="derive" @click="derive">导出到Excel</button>
        <button class="peg" @click="batchesSign">收款标记</button>
        <button class="more" @click="more">更多</button>
        <el-button
          type="danger"
          icon="el-icon-delete"
          size="mini"
          style="height: 30px; margin-left: 10px"
          @click="batchDelt"
        >
          批量删除
        </el-button>
        <el-button
          class="editbig"
          icon="el-icon-edit"
          size="mini"
          @click="visible = true"
        >
          修改考试大类
        </el-button>
        <button class="leadingOut" style="" @click="leadingOut">
          批量导出照片
        </button>
        <el-button
          class="editbig"
          icon="el-icon-edit"
          size="mini"
          @click="feeshow = true"
        >
          修改副证费
        </el-button>
      </div>
      <!-- 修改考试大类弹窗 -->
      <el-dialog title="修改考试大类" width="550px" :visible.sync="visible">
        <el-form
          :label-position="labelPosition"
          :rules="rule"
          ref="list"
          class="form-1"
          label-width="120px"
          :model="list"
        >
          <el-form-item label="选择考试大类" prop="bigCalss">
            <el-select
              v-model="list.bigCalss"
              filterable
              placeholder="请输入并选择考试大类"
              :clearable="true"
            >
              <el-option
                v-for="item in list.bigCalssChose"
                :key="item.id"
                :label="item.exam_name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <el-divider></el-divider>
        <div class="footer">
          <el-button
            style="background-color: #18bc9c; color: #ffffff"
            @click="submit('list')"
          >
            提交
          </el-button>
          <el-button
            style="background-color: #f5f5f5; color: #666"
            @click="reset('list')"
            >取消</el-button
          >
        </div>
      </el-dialog>
      <!-- 修改副证费弹窗 -->
      <el-dialog title="修改副证费" width="550px" :visible.sync="feeshow">
        <el-form
          ref="flist"
          class="form-1"
          label-width="120px"
          :rules="frule"
          :model="flist"
          :label-position="labelPosition"
        >
          <el-form-item label="副证费" prop="feenum">
            <el-input
              v-model="flist.feenum"
              placeholder="请输入副证费"
            ></el-input>
          </el-form-item>
        </el-form>
        <el-divider></el-divider>
        <div class="footer">
          <el-button
            style="background-color: #18bc9c; color: #ffffff"
            @click="feesubmit('flist')"
          >
            提交
          </el-button>
          <el-button
            style="background-color: #f5f5f5; color: #666"
            @click="feereset('flist')"
            >取消</el-button
          >
        </div>
      </el-dialog>

      <div class="" style="margin-right: 10px">
        <el-button
          size="small"
          style="background: #18bc9c; color: #ffffff"
          @click="query"
        >
          查询
        </el-button>
        <el-button
          size="small"
          style="background: #fafafa; color: #666666"
          @click="Reset"
        >
          重置
        </el-button>
      </div>
    </div>
    <!-- 表格 -->
    <el-table
      :data="tableData"
      border
      stripe
      @selection-change="checkAll"
      style="width: 97.9%; flex: 1"
      height="690"
      @sort-change="abc"
    >
      <!-- 复选按钮 -->
      <el-table-column type="selection" align="center" width="50">
      </el-table-column>
      <el-table-column type="index" label="序号" align="center" width="70">
      </el-table-column>
      <el-table-column prop="head_image" label="相片" align="center" width="80">
        <template slot-scope="scope">
          <img
            :src="scope.row.head_image"
            style="width: 15px; height: 20px; margin-top: 5px"
          />
        </template>
      </el-table-column>
      <el-table-column
        prop="org_name"
        sortable="custom"
        label="提供机构"
        align="center"
        width="150"
      >
      </el-table-column>
      <el-table-column
        prop="name"
        sortable="custom"
        label="学生姓名"
        align="center"
        width="120"
      >
      </el-table-column>
      <el-table-column
        prop="pinyin_name"
        sortable="custom"
        label="拼音名"
        align="center"
        width="150"
        :show-overflow-tooltip="true"
      >
      </el-table-column>
      <el-table-column
        prop="idcard"
        sortable="custom"
        label="身份证"
        align="center"
        width="200"
      >
      </el-table-column>
      <el-table-column
        prop="gender"
        sortable="custom"
        label="性别"
        align="center"
        width="80"
      >
        <template slot-scope="scope">
          <span v-if="scope.row.gender == 1">男</span>
          <span v-else-if="scope.row.gender == 2">女</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="birthday"
        sortable="custom"
        label="出生日期"
        align="center"
        width="150"
      >
      </el-table-column>
      <el-table-column
        prop="nation2"
        sortable="custom"
        label="国籍"
        align="center"
        width="100"
      >
      </el-table-column>
      <el-table-column
        prop="nation"
        sortable="custom"
        label="民族"
        align="center"
        width="100"
      >
      </el-table-column>
      <el-table-column
        prop="course"
        sortable="custom"
        label="考试科目"
        align="center"
        width="150"
      >
      </el-table-column>
      <el-table-column
        prop="original_level"
        sortable="custom"
        label="原等级"
        align="center"
        width="100"
      >
      </el-table-column>
      <el-table-column
        prop="exam_level"
        sortable="custom"
        label="等级"
        align="center"
        width="100"
      >
      </el-table-column>
      <el-table-column
        prop="phone"
        sortable="custom"
        label="联系电话"
        align="center"
        width="150"
        :show-overflow-tooltip="true"
      >
      </el-table-column>
      <el-table-column
        prop="status"
        sortable="custom"
        label="单据状态"
        align="center"
        width="120"
      >
        <template slot-scope="scope">
          <span v-if="scope.row.status == 0 || scope.row.status == ''"></span>
          <span v-else-if="scope.row.status == 1">草稿</span>
          <span v-else-if="scope.row.status == 2">报考</span>
          <span v-else-if="scope.row.status == 3">准考</span>
          <span v-else-if="scope.row.status == 4">考试OK</span>
          <span v-else-if="scope.row.status == 5">取消</span>
          <span v-else-if="scope.row.status == 6">退款取消</span>
          <span v-else-if="scope.row.status == 7">延期</span>
          <span v-else-if="scope.row.status == 8">缺考</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="is_receipt"
        label="机构收款"
        sortable="custom"
        align="center"
        width="120"
      >
        <template slot-scope="scope">
          <span v-if="scope.row.is_receipt == 0">未收款</span>
          <span v-else-if="scope.row.is_receipt == 1">已收款</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="is_transfer"
        label="过账状态"
        sortable="custom"
        align="center"
        width="150"
      >
        <template slot-scope="scope">
          <span v-if="scope.row.is_transfer == 0">未过账</span>
          <span v-else-if="scope.row.is_transfer == 1">已过账</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="is_deputy"
        label="是否副证"
        sortable="custom"
        align="center"
        width="120"
      >
        <template slot-scope="scope">
          <span v-if="scope.row.is_deputy == 0">否</span>
          <span v-else-if="scope.row.is_deputy == 1">是</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="enroll_number"
        label="报名单号"
        sortable="custom"
        align="center"
        width="150"
      >
      </el-table-column>
      <el-table-column
        prop="certificate_no"
        label="准考证号"
        sortable="custom"
        align="center"
        width="200"
      >
      </el-table-column>
      <el-table-column
        prop="exam_date"
        sortable="custom"
        label="报名日期"
        align="center"
        width="150"
      >
      </el-table-column>
      <el-table-column
        prop="apply"
        sortable="custom"
        label="申请考试大类"
        align="center"
        width="200"
      >
      </el-table-column>
      <el-table-column
        prop="exam2_date"
        sortable="custom"
        label="考试日期"
        align="center"
        width="150"
      >
      </el-table-column>
      <el-table-column
        prop="exam_startdate"
        sortable="custom"
        label="开始时间"
        align="center"
        width="150"
      >
      </el-table-column>
      <el-table-column
        prop="exam_enddate"
        sortable="custom"
        label="结束时间"
        align="center"
        width="150"
      >
      </el-table-column>
      <el-table-column
        prop="exam_duration"
        sortable="custom"
        label="时长(hr)"
        align="center"
        width="120"
      >
      </el-table-column>
      <el-table-column
        prop="enroll_price"
        sortable="custom"
        label="报名费(元)"
        align="center"
        width="120"
      >
      </el-table-column>
      <el-table-column
        prop="manage_price"
        sortable="custom"
        label="考级管理费(元)"
        align="center"
        width="150"
      >
      </el-table-column>
      <el-table-column
        prop="certificatecopy_price"
        sortable="custom"
        label="副证费(元)"
        align="center"
        width="120"
      >
      </el-table-column>
      <el-table-column
        prop="price1"
        label="应收金额(元)"
        sortable="custom"
        align="center"
        width="150"
      >
      </el-table-column>
      <el-table-column
        prop="price2"
        label="实收金额(元)"
        sortable="custom"
        align="center"
        width="150"
      >
      </el-table-column>
      <el-table-column
        prop="order_name"
        label="下单人"
        sortable="custom"
        align="center"
        width="120"
      >
      </el-table-column>
      <el-table-column
        prop="remark"
        label="考试备注"
        sortable="custom"
        align="center"
        width="200"
        :show-overflow-tooltip="true"
      >
      </el-table-column>
      <!--   <el-table-column prop="text_score" label="成绩" sortable="custom" align="center" width="80">
            </el-table-column> -->
      <el-table-column
        prop="exam_result"
        label="考试结论"
        sortable="custom"
        align="center"
        width="120"
      >
        <template slot-scope="scope">
          <span v-if="scope.row.status == 0 || scope.row.status == ''"></span>
          <span v-else-if="scope.row.exam_result == 1">未录入</span>
          <span v-else-if="scope.row.exam_result == 2">已通过</span>
          <span v-else-if="scope.row.exam_result == 3">未通过</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="exam_result"
        label="成绩等级"
        sortable="custom"
        align="center"
        width="120"
      >
        <template slot-scope="scope">
          <span v-if="scope.row.exam_result == 1">-</span>
          <span v-else-if="scope.row.exam_result == 2">
            {{ scope.row.exam_level }}
          </span>
          <span v-else-if="scope.row.exam_result == 3">
            {{ scope.row.original_level }}
          </span>
        </template>
      </el-table-column>
      <el-table-column
        prop="address"
        label="场地"
        sortable="custom"
        align="center"
        width="200"
        :show-overflow-tooltip="true"
      >
      </el-table-column>
      <el-table-column
        prop="add_name"
        label="录入人"
        sortable="custom"
        align="center"
        width="120"
      >
      </el-table-column>
      <el-table-column
        prop="add_time"
        label="录入时间"
        sortable="custom"
        align="center"
        width="200"
      >
      </el-table-column>
      <el-table-column
        prop="update_name"
        label="修改人"
        sortable="custom"
        align="center"
        width="120"
      >
      </el-table-column>
      <el-table-column
        prop="update_time"
        label="最近修改时间"
        sortable="custom"
        align="center"
        width="200"
      >
      </el-table-column>
      <el-table-column
        prop="difference"
        label="差额(元)"
        sortable="custom"
        align="center"
        width="120"
      >
      </el-table-column>
      <el-table-column
        prop="age"
        label="报考时年龄"
        sortable="custom"
        align="center"
        width="120"
      >
      </el-table-column>
      <el-table-column label="操作" align="center" width="280" fixed="right">
        <template slot-scope="scope">
          <el-button
            class="checkBtn"
            icon="el-icon-view"
            size="mini"
            @click="details(scope.$index, scope.row)"
          >
            详情
          </el-button>
          <el-button
            class="edit"
            icon="el-icon-edit"
            size="mini"
            @click="edit(scope.$index, scope.row)"
          >
            编辑
          </el-button>
          <el-button
            type="danger"
            icon="el-icon-delete"
            size="mini"
            @click="delt(scope.$index, scope.row)"
          >
            删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <!--分页 -->
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[20, 100, 500, 1000, 2000, 5000, 10000, 50000]"
      :page-size="10"
      background
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
    >
    </el-pagination>
    <!-- 单据汇总数据 -->
    <div
      class=""
      style="display: flex; margin-left: 22px; flex-direction: column"
    >
      <div
        class=""
        style="display: flex; flex-wrap: wrap; align-items: center"
        v-for="(item, index) in summary"
        :key="index"
      >
        <div class="txtbox" v-for="(value, key) in item" :key="key">
          {{ key }} :
          <input :value="value" type="text" class="itp" disabled="disabled" />
        </div>
      </div>
    </div>
    <!-- 打印预览弹出框 -->
    <el-dialog width="860px" :visible.sync="dialog" title="">
      <div id="printTest">
        <!-- 头部 -->
        <div class="top">
          <div class="top-logo">
            <img :src="printData.top_logo" />
          </div>
          <div class="top-title">社会美术水平考级中心全国美术等级考试</div>
        </div>
        <!-- 报名表 -->
        <div class="sign_up">报名表</div>
        <!-- 编号 -->
        <div class="" style="text-align: right">
          <div class="" style="margin-right: 40px; font-size: 16px">
            No:<span style="padding-left: 10px">{{ printData.number }}</span>
          </div>
        </div>
        <!-- 表格 -->
        <table border="1" cellspacing="0" cellpadding="0">
          <tr>
            <td class="td_1" rowspan="5"><img :src="printData.head_img" /></td>
            <td>所属地区：</td>
            <td>{{ printData.region }}</td>
            <td colspan="2"></td>
          </tr>
          <tr>
            <td>姓名</td>
            <td>{{ printData.name }}</td>
            <td class="td_2">性别</td>
            <td class="td_3">{{ printData.sex }}</td>
          </tr>
          <tr>
            <td>拼音名</td>
            <td>{{ printData.pinyin }}</td>
            <td class="td_2">国籍</td>
            <td class="td_3">{{ printData.nationality }}</td>
          </tr>
          <tr>
            <td>报考专业</td>
            <td>{{ printData.major }}</td>
            <td class="td_2">民族</td>
            <td class="td_3">{{ printData.nation }}</td>
          </tr>
          <tr>
            <td>原有级别</td>
            <td>{{ printData.original_grade }}</td>
            <td class="td_2">现报级别</td>
            <td class="td_3">{{ printData.level }}</td>
          </tr>
          <tr>
            <td>家庭住址</td>
            <td colspan="2">{{ printData.address }}</td>
            <td class="td_2">出生日期</td>
            <td class="td_3">{{ printData.birthday }}</td>
          </tr>
          <tr>
            <td>手机号码</td>
            <td colspan="2">{{ printData.phone }}</td>
            <td class="td_2">邮编</td>
            <td class="td_3">{{ printData.Zipcode }}</td>
          </tr>
          <tr>
            <td>考生证件号</td>
            <td colspan="2">{{ printData.idcard }}</td>
            <td class="td_2">电话</td>
            <td class="td_3">{{ printData.telephone }}</td>
          </tr>
          <tr>
            <td>备注</td>
            <td colspan="4" class="remarks">
              一、本表系录入全国社会美术考级数据库及考生等级证书的依据，
              请考生务必用正楷字如实填写。因填表错误而造成证书重做，考生必须负担证书重做的工本费。<br />
              二、一经报名，不得退考、更改考试科目、报考级别。<br />
              三、因考生本人原因缺考视为自动弃权，恕不退费和补考。
            </td>
          </tr>
        </table>

        <!-- 打印预览底部 -->
        <div class="bottom">
          <!-- 考点经办人(签章) -->
          <div class="handle">考点经办人(签章)：<input type="text" /></div>
          <div class="bottom_text">
            <p>中国美术学院社会美术水平考级中心</p>
            <p>深圳书画艺术学院考级办公室</p>
          </div>
          <div class="phone_date">
            <span>电话：0755-8883 0206</span>
            <span>{{ printData.specificDate }}</span>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialog = false">取 消</el-button>
        <el-button
          style="background: #18bc9c; color: #fff"
          v-print="'#printTest'"
          >打 印</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      startdate: "", //开始日期
      enddate: "", //结束日期
      form: {
        usesearch: "",
        dateQuery: [], //查询日期
        fullName: "", //人员姓名
        search: "", //关键字
        condition: "", //单据状态
        conditionChoose: [
          {
            value: 0,
            label: "全部",
          },
          {
            value: 1,
            label: "草稿",
          },
          {
            value: 2,
            label: "报考",
          },
          {
            value: 3,
            label: "准考",
          },
          {
            value: 4,
            label: "考试OK",
          },
          {
            value: 5,
            label: "取消",
          },
          {
            value: 6,
            label: "退款取消",
          },
          {
            value: 7,
            label: "延期",
          },
          {
            value: 8,
            label: "缺考",
          },
        ], //单据状态选择
        mechanism: "", //机构
        mechanismChoose: [], //机构选择
        abnormal: 0, //异常
        abnormalChoose: [
          { value: 0, label: "全部" },
          { value: 1, label: "无科目报名" },
          { value: 2, label: "无机构报名" },
          { value: 3, label: "无照片" },
          { value: 4, label: "无国籍" },
          { value: 5, label: "无民族" },
          { value: 6, label: "无性别" },
          { value: 7, label: "出生日期异常" },
          { value: 8, label: "拼音异常" },
          { value: 9, label: "身份证异常" },
        ], //异常选择
        exam: "", //考试大类
        examOpt: [], //考试大类选项
        subject: "", //科目
        subjectOpt: [], //科目选项
        grade: "", //报考等级
        gradeOpt: [], //报考等级选项
        arrange: 0,
        arrangeOpt: [
          { value: 0, label: "全部" },
          { value: 1, label: "未安排" },
          { value: 2, label: "已安排" },
        ],
      },
      tableData: [],
      currentPage: 1, //页数
      currentLimit: 20, //条数
      total: 0, //总数
      ids: [],
      dialog: false, //判断打印预览开关
      id: "",
      visible: false, //考试大类弹窗开关
      feeshow: false, //副证费弹窗开关
      labelPosition: "right",
      flist: {
        feenum: "",
      },
      rules: {
        examineIdea: [
          { required: true, message: "请选择考试大类", trigger: "change" },
        ],
      },
      list: {
        bigCalss: "", //考试大类
        bigCalssChose: [], //考试大类选择
      },
      rule: {
        bigCalss: [
          { required: true, message: "请选择考试大类", trigger: "change" },
        ],
      },
      frule: {
        feenum: [
          { required: true, message: "请输入考证费", trigger: "change" },
        ],
      },
      printData: {
        top_logo: require("../../assets/s-logo.png"), //logo
        number: "", //编号
        head_img: "", //头像
        region: "", //所属地区
        name: "", //姓名
        sex: "", //性别
        pinyin: "", //拼音名
        nationality: "", //国籍
        nation: "", //民族
        major: "", //报考专业
        original_grade: "", //原有级别
        level: "", //现报等级
        address: "", //家庭住址
        birthday: "", //出生日期
        phone: "", //手机号码
        idcard: "", //考试证件号
        Zipcode: "", //邮编
        telephone: "", //电话
        remarks: "", //备注
        specificDate: "", //日期
      },
      summary: [
        {
          草稿: 0,
          应收金额: 0,
          报名费合计: 0,
          管理费合计: 0,
          副证费合计: 0,
          实收金额: 0,
        },
        {
          报名: 0,
          应收金额: 0,
          报名费合计: 0,
          管理费合计: 0,
          副证费合计: 0,
          实收金额: 0,
        },
        {
          准考: 0,
          应收金额: 0,
          报名费合计: 0,
          管理费合计: 0,
          副证费合计: 0,
          实收金额: 0,
        },
        {
          考试OK: 0,
          应收金额: 0,
          报名费合计: 0,
          管理费合计: 0,
          副证费合计: 0,
          实收金额: 0,
        },
        {
          取消: 0,
          应收金额: 0,
          报名费合计: 0,
          管理费合计: 0,
          副证费合计: 0,
          实收金额: 0,
        },
        {
          退款取消: 0,
          应收金额: 0,
          报名费合计: 0,
          管理费合计: 0,
          副证费合计: 0,
          实收金额: 0,
        },
        {
          延期: 0,
          应收金额: 0,
          报名费合计: 0,
          管理费合计: 0,
          副证费合计: 0,
          实收金额: 0,
        },
        {
          缺考: 0,
          应收金额: 0,
          报名费合计: 0,
          管理费合计: 0,
          副证费合计: 0,
          实收金额: 0,
        },
      ],
      arr: [],
    };
  },
  created() {
    this.getList();
    // this.getTime();

    // 选择机构
    this.$request({
      url: "/api/mechanism/list",
      method: "POST",
      data: {
        page: 1,
        limit: 1000,
      },
    }).then((res) => {
      // console.log("选择机构",res.data.list)
      this.form.mechanismChoose = res.data.list;
    });

    // 考试大类
    this.$request({
      url: "/api/ExamCategory/list",
      method: "POST",
      data: {
        page: 1,
        limit: 1000,
      },
    }).then((res) => {
      // console.log(res,"考试大类")
      if (res.code == 1) {
        this.list.bigCalssChose = res.data.list;
        this.form.examOpt = res.data.list;
      }
    });

    // 选择科目
    this.$request({
      url: "/api/course/list",
      method: "POST",
      data: {
        page: 1,
        limit: 1000,
      },
    }).then((res) => {
      console.log("选择科目", res.data.list);
      this.form.subjectOpt = res.data.list;
    });

    // 选择等级
    this.$request({
      url: "/api/level/list",
      method: "POST",
      data: {
        page: 1,
        limit: 1000,
      },
    }).then((res) => {
      console.log("选择等级", res.data.list);
      this.form.gradeOpt = res.data.list;
    });
  },
  activated() {
    this.getList();
    // console.log("页面缓存")
  },
  methods: {
    getTime() {
      // console.log(111)
      let now = new Date();
      let year = now.getFullYear();
      let month = now.getMonth() + 1; //0-11表示1-12月
      month = month.toString().padStart(2, "0"); //当小于10时，显示为01.02.03
      let day = now.getDate();
      day = day.toString().padStart(2, "0"); //当小于10时补0
      this.enddate = year + "-" + month + "-" + day;
      console.log(this.enddate, "当前时间");
      let nowMonthDay = new Date(year, month, 0).getDate(); //当前月的总天数
      if (month - 6 <= 0) {
        //如果是1、2、3月，年数往前推一年
        let last3MonthDay = new Date(
          year - 1,
          12 - (6 - parseInt(month)),
          0
        ).getDate(); //3个月前所在月的总天数
        if (last3MonthDay < day) {
          //3个月前所在月的总天数小于现在的天日期
          this.enddate =
            year -
            1 +
            "-" +
            (12 - (6 - month)).toString().padStart(2, "0") +
            "-" +
            last3MonthDay;
        } else {
          this.startdate =
            year -
            1 +
            "-" +
            (12 - (6 - month)).toString().padStart(2, "0") +
            "-" +
            day;
        }
      } else {
        let last3MonthDay = new Date(year, parseInt(month) - 6, 0).getDate(); //3个月前所在月的总天数
        if (last3MonthDay < day) {
          //3个月前所在月的总天数小于现在的天日期
          if (day < nowMonthDay) {
            //当前天日期小于当前月总天数,2月份比较特殊的月份
            this.enddate =
              year +
              "-" +
              (month - 6).toString().padStart(2, "0") +
              "-" +
              (last3MonthDay - (nowMonthDay - day));
          } else {
            this.startdate =
              year +
              "-" +
              (month - 6).toString().padStart(2, "0") +
              "-" +
              last3MonthDay;
          }
        } else {
          this.startdate =
            year + "-" + (month - 6).toString().padStart(2, "0") + "-" + day;
        }
      }
      this.form.dateQuery[0] = this.startdate;
      this.form.dateQuery[1] = this.enddate;
      console.log(this.form.dateQuery, "三个月区间段");
    },
    getList() {
      console.log(this.form.dateQuery, "query");
      this.$request({
        url: "/api/examenroll/list",
        method: "POST",
        data: {
          page: this.currentPage,
          limit: this.currentLimit,
          dateQuery: this.form.dateQuery, //查询时间
          search: this.form.search, //关键字
          status: this.form.condition, //单据状态
          org_id: this.form.mechanism, //机构id
          type: this.form.abnormal, //异常
          apply_category: this.form.exam,
          exam_level: this.form.grade, //等级
          course_id: this.form.subject, //科目
          sort: this.arr,
          exam_arrange: this.form.arrange,
          agroup: this.form.usesearch,
        },
      }).then((res) => {
        // console.log('列表', res)
        this.tableData = res.data.list;
        this.total = res.data.count;
        // let sum = res.data.sum
        // console.log(this.summary)
        // console.log(res.data.sum);
        res.data.sum.forEach((item, index) => {
          let summaryItem = this.summary[index];
          let startKeys = Object.keys(summaryItem)[0];
          summaryItem[startKeys] = item.count;

          summaryItem["应收金额"] = item.price1;
          summaryItem["报名费合计"] = item.enroll_price;
          summaryItem["管理费合计"] = item.manage_price;
          summaryItem["副证费合计"] = item.certificatecopy_price;
          summaryItem["实收金额"] = item.price2;
        });
      });
    },
    query() {
      //查询
      this.currentPage = 1;
      this.getList();
    },

    Reset() {
      //重置
      this.form.dateQuery = []; //查询时间
      this.form.search = ""; //关键字
      this.form.condition = ""; //单据状态
      this.form.mechanism = ""; //机构id
      this.form.abnormal = 0; //异常
      this.form.exam = "";
      this.form.grade = ""; //等级
      this.form.subject = ""; //科目
      this.form.arrange = 0;
      this.form.usesearch = "";
      this.getList();
    },
    handleSizeChange(val) {
      // console.log(`每页 ${val} 条`);
      this.currentLimit = val;
      this.getList();
    },
    handleCurrentChange(val) {
      // console.log(`当前页: ${val}`);
      this.currentPage = val;
      this.getList();
    },
    // 刷新
    refresh() {
      this.$router.push({
        path: "/home/newpage", //空页面路由
        query: {
          path: this.$route.path,
        },
      });
    },
    newlyAdded() {
      //新增
      this.$router.push({
        path: "addRegister",
      });
    },
    edit(index, row) {
      //编辑
      this.$router.push({
        path: "editRegister",
        query: {
          id: row.id,
        },
      });
    },
    delt(index, row) {
      //删除
      this.$confirm("是否删除此条记录?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$request({
          url: "/api/examenroll/del",
          method: "POST",
          data: {
            id: row.id,
          },
        }).then((res) => {
          if (res.code == 1) {
            this.$message({
              message: res.msg,
              type: "success",
            });
            this.tableData.splice(index, 1);
            this.getList();
          }
        });
      });
    },
    more() {
      //更多
      this.$router.push({
        path: "registerForm",
      });
    },
    details(index, row) {
      //详情
      this.$router.push({
        path: "registerDetails",
        query: {
          id: row.id,
        },
      });
    },
    checkAll(selection) {
      //获取批量收款id
      console.log(selection);
      this.ids = [];
      this.id = "";
      selection.forEach((item) => {
        this.ids.push(item.id);
        this.id = item.id;
      });
      // console.log(this.id)
    },
    batchesSign() {
      //收款标记
      this.$confirm("是否标记?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$request({
          url: "/api/examenroll/receipt",
          method: "POST",
          data: {
            ids: this.ids,
          },
        }).then((res) => {
          if (res.code == 1) {
            this.$message({
              message: "标记成功",
              type: "success",
            });
            this.getList();
          } else {
            this.$message({
              message: res.msg,
              type: "error",
            });
            this.getList();
          }
        });
      });
    },
    batchDelt() {
      //批量删除
      this.$confirm("是否删除所选中的记录?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$request({
          url: "/api/examenroll/del",
          method: "POST",
          data: {
            id: this.ids,
          },
        }).then((res) => {
          if (res.code == 1) {
            this.$message({
              message: res.msg,
              type: "success",
            });
            this.getList();
          }
        });
      });
    },
    derive() {
      //导出
      location.href = `https://artxt.szart.cn/api/public/index.php/api/examenroll/export?
                    page=${this.currentPage}&limit=${this.currentLimit}&dateQuery=${this.form.dateQuery}
                    &search=${this.form.search}&status=${this.form.condition}&org_id=${this.form.mechanism}
                    &type=${this.form.abnormal}&apply_category=${this.form.exam}&course_id=${this.form.subject}
                    &exam_level=${this.form.grade}&exam_arrange=${this.form.arrange}&agroup=${this.form.usesearch}`;
    },
    arrange() {},
    print() {
      // console.log('打印预览')
      this.dialog = true;
      this.$request({
        url: "/api/examenroll/print",
        method: "POST",
        data: {
          id: this.id,
        },
      }).then((res) => {
        console.log(res);
        if (res.code == 1) {
          this.$message({
            message: res.msg,
            type: "success",
          });
          // printData
          let data = res.data;
          let printData = this.printData;
          printData.number = data.enroll_number; //编号
          printData.head_img = data.student.head_image; //头像
          printData.region = data.area; //所属地区
          printData.name = data.name; //姓名
          printData.sex = data.student.gender; //性别
          printData.pinyin = data.english_name; //拼音名
          printData.nationality = data.student.nation2; //国籍
          printData.nation = data.student.nation; //民族
          printData.major = data.course; //报考专业
          printData.original_grade = data.original_level; //原有级别
          printData.level = data.exam_level; //现报等级
          printData.address = data.student.address; //家庭住址
          printData.birthday = data.student.birthdate; //出生日期
          printData.phone = data.student.mobile1; //手机号码
          printData.idcard = data.idcard; //考试证件号
          printData.Zipcode = data.student.post_code; //邮编
          // printData.telephone= data.//电话
          printData.specificDate = data.print_date; //日期
        } else {
          this.$message({
            message: res.msg,
            type: "error",
          });
        }
      });
    },
    // 姓名排序
    fn2(a, b) {
      return a.name.localeCompare(b.name);
    },

    //修改考试大类
    submit(list) {
      this.$refs[list].validate((valid) => {
        if (valid) {
          this.$request({
            url: "/api/examenroll/exam_category",
            method: "POST",
            data: {
              ids: this.ids,
              examcategory_id: this.list.bigCalss,
            },
          })
            .then((res) => {
              if (res.code == 1) {
                this.$message({
                  message: res.msg,
                  type: "success",
                });
                this.visible = false;
                this.getList();
                this.$refs[list].resetFields();
              } else {
                this.$message({
                  message: res.msg,
                  type: "error",
                });
                this.visible = false;
              }
            })
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    reset(list) {
      this.visible = false;
      this.$refs[list].resetFields();
    },

    //修改副证费
    feesubmit(flist) {
      this.$refs[flist].validate((valid) => {
        if (valid) {
          this.$request({
            url: "/api/examenroll/certificatecopy_price",
            method: "POST",
            data: {
              ids: this.ids,
              certificatecopy_price: this.flist.feenum,
            },
          }).then((res) => {
            if (res.code == 1) {
              this.$message({
                message: res.msg,
                type: "success",
              });
              this.getList();
              this.$refs[flist].resetFields();
              this.feeshow = false;
            } else {
              this.$message({
                message: res.msg,
                type: "error",
              });
              this.feeshow = false;
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    feereset(flist) {
      this.feeshow = false;
      this.$refs[flist].resetFields();
    },
    //排序
    abc(i) {
      console.log(i);
      this.tableData = [];
      this.arr = [];
      this.arr.push({
        title: i.prop,
        order: i.order,
      });
      console.log(this.arr);
      this.getList();
    },
    //批量导出照片
    leadingOut() {
      console.log("批量导出照片");
      let ids = this.ids;
      if (ids.length) {
        this.$request({
          url: "/api/examenroll/img_zip",
          method: "POST",
          data: {
            ids: this.ids,
          },
        }).then((res) => {
          location.href = `${res.data}`;
          console.log(res.data, "454545");
        });
      } else {
        this.$message({
          message: "id不能为空！",
          type: "error",
        });
      }
    },
  },
};
</script>

<style scoped="scoped">
.register {
  width: 100%;
  height: 100%;
  /* display: flex;
        flex-direction: column; */
}

/* 查询部分 */
.form {
  padding-top: 34px;
  display: flex;
  /* justify-content: space-between; */
  flex-wrap: wrap;
}

.form ::v-deep .el-input__inner {
  width: 276px;
  height: 37px;
}

.form ::v-deep .el-form-item__label {
  color: #000000;
}
.el-dialog__body .el-select {
  width: 300px;
}

::v-deep .footer {
  margin: 15px 0px !important;
  text-align: center !important;
  /* height: 50px !important; */
}
/* 按钮 */
::v-deep .el-icon-refresh {
  font-weight: bold !important;
  color: #ffffff;
}

::v-deep .el-icon-plus {
  font-weight: bold !important;
}

/* 打印预览 */
.print {
  display: inline-block;
  padding-left: 10px;
  width: 94px;
  height: 30px;
  border-radius: 3px;
  vertical-align: middle;
  background: url(../../assets/print.png) 8px 9px no-repeat #18bc9c;
  border: none;
  color: #ffffff;
  margin: 0px 10px;
  cursor: pointer;
  outline: none;
}

/* 导出按钮 */
.derive,
.leadingOut {
  display: inline-block;
  width: 113px;
  height: 30px;
  padding-left: 10px;
  vertical-align: middle;
  background: url(../../assets/export.png) 6px 6px no-repeat #ff7300;
  color: #ffffff;
  border-radius: 3px;
  border: none;
  margin-right: 10px;
  cursor: pointer;
  outline: none;
}
/* 批量导出照片 */
.leadingOut {
  margin-left: 10px;
  display: inline-block;
}
/* 收款标记按钮 */
.peg {
  display: inline-block;
  margin-right: 10px;
  width: 90px;
  height: 30px;
  padding-left: 10px;
  vertical-align: middle;
  background: url(../../assets/biaoji.png) 6px 8px no-repeat #ff7300;
  color: #ffffff;
  border-radius: 3px;
  border: none;
  cursor: pointer;
  outline: none;
}

/* 更多 */
.more {
  display: inline-block;
  width: 70px;
  height: 30px;
  vertical-align: middle;
  background: url(../../assets/more.png) 10px 8px no-repeat #29726c;
  color: #ffffff;
  border-radius: 3px;
  padding-left: 18px;
  border: none;
  cursor: pointer;
  outline: none;
}

/* 表格 */
.el-table {
  margin: 20px;
}

::v-deep .el-table__cell {
  color: #000;
  padding: 0;
  height: 30px;
}

.checkBtn {
  color: #ffffff;
  background: #18bc9c;
  font-size: 12px;
  border-radius: 2px;
  /* border: none; */
}
.editbig {
  background: #ff7300;
  color: #ffffff;
  height: 30px;
  border: none;
}

.el-form-item__content {
  text-align: center;
}
.edit {
  background: #ff7300;
  color: #ffffff;
}

/* 分页 */
.el-pagination {
  margin: 20px;
  margin-top: 0px;
}

::v-deep.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #2c3e50 !important;
}

/* 汇总数据 样式*/
.txtbox {
  width: 180px;
  height: 19px;
  display: flex;
  justify-content: space-between;
  margin-bottom: 18px;
  margin-right: 10px;
  font-size: 14px;
  color: #000000;
}

.itp {
  /* border: none; */
  width: 90px;
  height: 22px;
  outline: none;
  font-size: 14px;
  background-color: #ffffff;
  border: 1px solid #ccc;
  padding-left: 5px;
}

/* 打印弹出样式 */
.register ::v-deep .el-dialog__body {
  padding: 20px 15px;
}

.register ::v-deep .el-dialog__footer {
  padding: 10px 20px 20px !important;
  text-align: center;
}

#printTest {
  width: 800px;
  /* height: 500px; */
  /* border: 1px #ccc solid; */
  margin: 0px auto;
  color: #333;
}

.top {
  width: 100%;
  height: 80px;
  /* border: 1px solid red; */
  display: flex;
  justify-content: space-between;
}

.top-logo {
  width: 350px;
  height: 100%;
}

.top-logo img {
  width: 100%;
  height: 100%;
}

.top-title {
  font-size: 18px;
  font-weight: bold;
  color: #333;
  letter-spacing: 5px;
}

.sign_up {
  text-align: center;
  font-size: 30px;
  font-weight: bold;
  color: #333;
  letter-spacing: 5px;
}

/* 打印预览表格 */
table {
  margin-top: 10px;
  width: 100%;
  border-collapse: collapse;
  text-align: center;
  font-weight: bold;
}

table td {
  height: 30px;
}

table td:first-child {
  width: 15%;
}

/* 相片 */
.td_1 img {
  width: 90px;
  height: 130px;
  /* border: 1px dashed #ccc; */
  margin: auto;
}

.td_2 {
  width: 85px;
}

.td_3 {
  width: 130px;
}

table tr:last-child {
  height: 100px;
}

.remarks {
  font-size: 14px;
  font-weight: 500;
  font-family: Microsoft YaHei;
  color: #000000;
  text-align: left;
  padding-left: 10px;
}

/* 底部 */
.bottom {
  text-align: right;
}

.handle {
  margin: 20px 0px;
  font-size: 17px;
  font-weight: bold;
  color: #000000;
}

.handle input {
  border: none;
  outline: none;
}

.bottom_text p {
  font-size: 15px;
  color: #000000;
  padding-right: 10px;
}

.phone_date {
  margin-top: 10px;
  color: #000000;
}

.phone_date span {
  display: inline-block;
}

.phone_date span:first-child {
  padding-right: 20px;
}

.phone_date span:last-child {
  padding: 0px 10px;
}
</style>
